export const getCategoryIds = (allCategories = [], categories = []) =>
  allCategories
    .filter((item) =>
      categories.some(
        (name) => item.name?.en?.toLowerCase() === name.toLowerCase()
      )
    )
    .map((item) => item._id);